import Vue from 'vue'
import VueRouter from 'vue-router'
import login from "../components/login/login.vue"
import system from "../components/login/system.vue"
import register from "../components/register/index.vue"
import retrieve from "../components/retrieve/index.vue"
import registerStepOne from "../components/register/stepOne.vue"
import main from "../components/index.vue"
import message from "../components/message/index"
import staging from "../components/staging/index"
import home from "../components/home/index"
import search from "../components/search/index"
import app from "../components/app/index"
import editApp from "../components/app/edit"
import worksheet from "../components/worksheet/index"
import createRow from "../components/row/createRow"
import updateRow from "../components/row/updateRow"
import editWorksheet from "../components/worksheet/edit"
import workflowInstance from "../components/message/workflowInstance"
import workflowApprove from "../components/message/workflowApprove"
import messagelist1 from "../components/message/list1"
import myprocess from '@/components/myProcess/index'
import todo from '@/components/myProcess/todoList'
import faqi from '@/components/myProcess/faqiList'
import completed from '@/components/myProcess/completedList'
import processform from '@/components/myProcess/processForm'
import workflowFillIn from '@/components/myProcess/workflowFillIn'

import { getToken } from "../util/author"

Vue.use(VueRouter)


const routes = [
    { path: '/', redirect: '/main' },
    { path: '/login', name: 'login', component: login, meta: {requiresAuth: false, keepAlive: false, leaveAppBack: true} },
    { path: '/system', name: 'system', component: system, meta: {requiresAuth: false, keepAlive: true, leaveAppBack: true} },
    { 
        path: '/register', 
        name: 'register',
        redirect: '/register/1',
        component: register,
        meta: { requiresAuth: false, keepAlive: false, leaveAppBack: true },
        children: [
            { path: '1', name: 'register1', component: registerStepOne, meta: { requiresAuth: false, keepAlive: false, leaveAppBack: false}}
        ]
    },
    { path: '/retrieve', name: 'retrieve', component: retrieve, meta: {requiresAuth: false, keepAlive: false, leaveAppBack: true} },
    { 
        path: '/main', 
        name: 'main',
        redirect: '/main/staging',
        component: main,
        meta: { requiresAuth: true, keepAlive: true, leaveAppBack: true },
        children: [
            { path: 'message', name: 'message', component: message, meta: { requiresAuth: true, keepAlive: true, leaveAppBack: true}},
            { path: 'staging', name: 'staging', component: staging, meta: { requiresAuth: true, keepAlive: true, leaveAppBack: true}},
            { path: 'home', name: 'home', component: home, meta: { requiresAuth: true, keepAlive: false, leaveAppBack: true }}
        ]
    },
    { path: '/search', name: 'search', component: search, meta: { requiresAuth: true, keepAlive: false } },
    { path: '/app/:appId', name: 'app', component: app, meta: { requiresAuth: true, keepAlive: false } },
    { path: '/editApp/:appId', name: 'editApp', component: editApp, meta: { requiresAuth: true, keepAlive: false } },
    { path: '/worksheet/:worksheetId', name: 'worksheet', component: worksheet, meta: { requiresAuth: true, keepAlive: false } },
    { path: '/editWorksheet/:worksheetId', name: 'editWorksheet', component: editWorksheet, meta: { requiresAuth: true, keepAlive: false } },
    { path: '/createRow/:worksheetId', name: 'createRow', component: createRow, meta: { requiresAuth: true, keepAlive: false } },
    { path: '/updateRow/:worksheetId/:rowId', name: 'updateRow', component: updateRow, meta: { requiresAuth: true, keepAlive: false } },
    { path: '/workflowInstance/:tableId/:rowId', name: 'workflowInstance', component: workflowInstance, meta: { requiresAuth: true, keepAlive: false } },
    { path: '/workflowApprove/:tableId', name: 'workflowApprove', component: workflowApprove, meta: { requiresAuth: true, keepAlive: false } },
    { path:'/messagelist1',name:'messagelist1',component:messagelist1,meta: { requiresAuth: true, keepAlive: false}},
    { 
        path:'/myprocess', 
        name:'myprocess', 
        redirect: '/myprocess/todo',
        component:myprocess,
        meta: { requiresAuth: true, keepAlive: false},
        children: [
            { path: 'todo', name: 'todo', component: todo, meta: { requiresAuth: true, keepAlive: false, leaveAppBack: false}},
            { path: 'faqi', name: 'faqi', component: faqi, meta: { requiresAuth: true, keepAlive: false, leaveAppBack: false}},
            { path: 'completed', name: 'completed', component: completed, meta: { requiresAuth: true, keepAlive: false, leaveAppBack: false }}
        ]
    },
    { path:'/processform/:id/:type', name:'processform', component: processform, props: true, meta: { requiresAuth: true, keepAlive: false}},
    { path:'/workflowFillIn/:id', name:'workflowFillIn', component: workflowFillIn, props: true, meta: { requiresAuth: true, keepAlive: false}},
]

const router = new VueRouter({
    // mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    // ...
    // 返回 false 以取消导航
    if(to.meta?.requiresAuth){
        if(getToken()){
            next()
        } else {
            next({path: '/login'})
        }
    } else {
        next()
    }
  })
export default router